import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { featureFlagEnabled } from '../config/modulos';

export default function FeatureGate({ flag, children, fallback = null, redirectTo = '/app' }) {
  const { usuario, empresa } = useAuth();

  if (usuario?.rol === 'superadmin') return children;
  if (!flag || featureFlagEnabled(empresa, flag)) return children;

  if (fallback) return fallback;
  return <Navigate to={redirectTo} replace />;
}
